import React from 'react';
import * as ROUTES from '../../constants/routes';
import { Redirect } from 'react-router-dom'
import { withFirebase } from '../Firebase'
import SoundtrailList from '../SoundtrailList/SoundtrailList'

import './index.css'

const HomePage = () => (
    <div>
        <HomePageWithFirebase />
    </div>
)

const HomePageBase = (props) => {
    if (props.firebase.auth.currentUser == null) {
        return <Redirect to={ROUTES.SIGN_IN} />;
    }
    return (<div className='App'><SoundtrailList /></div>)
}
const HomePageWithFirebase = withFirebase(HomePageBase);

export default HomePage;